const parentComms = (
  type: 'abort' | 'success' | 'fail' | 'close',
  payload = {},
): void => {
  window.parent?.postMessage({ source: 'journey', type, payload }, '*')
}

export default parentComms
